<template>
    <div class="container containerBox">
        <div style="margin-bottom: 10px;">
            <el-button type="primary" size="medium" @click="GatewayAdd" v-has="'collector'">+ 添加集控器</el-button>
            <el-button type="primary" icon="el-icon-refresh" size="medium" @click="handleReload">刷新</el-button>
        </div>
        
        <el-table :data="tableData" style="width: 100%" v-loading="loading">
            <el-table-column prop="dev_serial" label="序列号">
            </el-table-column>
            <el-table-column prop="dev_name" label="名称">
            </el-table-column>
            <el-table-column prop="online_status" label="在线状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.online_status === 1 ? 'success': 'danger'">{{fmtStatus(scope.row)}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="ipaddress" label="IP地址">
            </el-table-column>
            <el-table-column prop="port" label="端口号">
            </el-table-column>
            <el-table-column prop="description" label="备注">
            </el-table-column>
            <el-table-column prop="assigned_status" label="状态" :formatter="fmtAssignedStatus">
            </el-table-column>
            <el-table-column label="操作" width="180" fixed="right">
                <!-- 在线才能操作 -->
                <template slot-scope="scope">
                    <el-button type="text" v-has="'collector'" @click="handleAddClick(scope.row)">添加表计</el-button>
                    <el-button type="text" v-has="'collector'" @click="handleReplaceClick(scope.row)">替换</el-button>
                    <el-button type="text" v-has="'collector'" @click="handleDeleteClick(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="集控器替换" :visible.sync="replaceVisible" width="35%" :before-close="handleReplaceClose">
            <el-form label-width="110px" :rules="rules" ref="gatewayForm" :model="gatewayForm">
                <!-- <el-form-item label="序列号" prop="deviceSerial">
                    <el-input v-model="gatewayForm.deviceSerial" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="名称" prop="dev_name">
                    <el-input v-model="gatewayForm.dev_name"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="gatewayForm.description"></el-input>
                </el-form-item> -->
                <el-form-item label="新序列号" prop="newDeviceSerial">
                    <el-input v-model="gatewayForm.newDeviceSerial" placeholder="请输入替换序列号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitGatewayForm">确定并保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <cmp-gatewaydialog v-if="modalVisible" :modalShow.sync="modalVisible"></cmp-gatewaydialog>
    </div>
</template>

<script>
import CmpGatewaydialog from './CmpGatewayDialog'
import Service from '@/api/Service'
import {$Alert, funFmtOnlineStatus} from '@/utils/utils'
export default {
    name: "GatewayTable",
    inject: ["reload"],
    data() {
        return {
            tableData: [],
            gatewayForm: {},    //  替换集控器信息
            gatewayReplaceForm: {
                controlAddress: ''
            },
            // 替换集控器表单验证
            rules: {
                // deviceSerial: [{required: true, message: '请输入序列号', trigger: 'blur'}],
                // dev_name: [{required: true, message: '请输入名称', trigger: 'blur'}],
                newDeviceSerial: [{required: true, message: '请输入替换序列号', trigger: 'blur'}],
            },
            replaceVisible: false,
            modalVisible: false, // 新增、编辑弹框
            loading: false,
        };
    },
    components: {
        CmpGatewaydialog
    },
    mounted() {
        this.getList();
    },
    methods: {
        // 获取集控器列表
        async getList() {
            this.loading = true;
            let data = await Service.getCollector();
            this.loading = false;
            if(data){
                data = data === 'success' ? [] : data;
                this.tableData = data;
            }
        },
        handleReload() {
            this.getList();
        },
        // 设备状态
        fmtAssignedStatus(row) {
            switch (row.assigned_status) {
                case 1:
                    return  '已注册'
                case 0:
                    return  '未注册'
                default:
                    break;
            }
        },
        // 格式通讯状态
        fmtStatus(row, column) {
            return funFmtOnlineStatus(row.online_status)
        },
        // 添加集控器
        GatewayAdd() {
            this.modalVisible = true;
        },
        // 添加表计
        handleAddClick(data) {
            this.$router.push("/gateway/addmeter/" + data.oid)
        },
        // 删除
        handleDeleteClick(data) {
           $Alert(`是否确认删除 ${data.dev_name} `).then( async (bool)=>{
                if(bool){
                    let res = await Service.deleteCollector({OID: data.oid});
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.reload();
                    }
                }
           });
        },
        // 替换
        handleReplaceClick(data) {
            this.replaceVisible = true;
            let {dev_name, description, dev_serial, oid } = data;

            this.gatewayForm = {
                oid: oid,
                dev_name: dev_name,
                description: description,
                deviceserial: dev_serial,
                newDeviceSerial: '',
            }
        },
        // 替换保存按钮
        submitGatewayForm() {
            this.$refs['gatewayForm'].validate(async (valid) => {
                if(valid) {
                    let data = await Service.changeCollector(this.gatewayForm);
                    if(data){
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
                        this.reload();
                    }
                }
            })
        },
        // 替换关闭按钮
        handleReplaceClose() {
            this.replaceVisible = false;
        }
    }
};
</script>

<style scoped>
</style>
